import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ConnectWalletModal from "./ConnectWalletModal";
import "./airdrops.css";

const AirdropDetails = () => {
  const [isWalletModalOpen, setIsWalletModalOpen] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleOpenModal = (e) => {
    if (e) e.preventDefault();
    setIsWalletModalOpen(true);
  };

  return (
    <div className="airdrop-details-page">
      <div className="airdrop-details-container">


        {/* --- Hero Section --- */}
        <div className="airdrop-detail-hero">
          <div className="airdrop-detail-hero-left">
            <div className="airdrop-breadcrumb">
              <Link to="/airdrops" className="breadcrumb-link">
                AGCX
              </Link>
              <span className="breadcrumb-sep">&gt;</span>
              <span className="breadcrumb-current">Web3 Newbie Trading Pair</span>
            </div>
            <h1 className="airdrop-detail-title">
              Trade &amp; Share up to{" "}
              <span className="gold-gradient-text">20,000 USDC</span>
            </h1>
            <p className="airdrop-detail-desc">
              Complete tasks, earn rewards and unlock exciting bonuses on AGCX.
            </p>

            {/* Event Countdown Timer */}
            <div className="airdrop-countdown-wrap">
              <span className="countdown-label">Event ends in:</span>
              <div className="countdown-boxes">
                <div className="timer-box">
                  <span className="timer-val">02</span>
                  <span className="timer-unit">Days</span>
                </div>
                <div className="timer-box">
                  <span className="timer-val">14</span>
                  <span className="timer-unit">Hrs</span>
                </div>
                <div className="timer-box">
                  <span className="timer-val">38</span>
                  <span className="timer-unit">Mins</span>
                </div>
                <div className="timer-box">
                  <span className="timer-val">47</span>
                  <span className="timer-unit">Sec</span>
                </div>
              </div>
            </div>

            {/* Meta Row: Participants & Rules */}
            <div className="airdrop-meta-row">
              <span className="participants-text">
                <i className="ri-group-line"></i> Participants: <strong>5,842</strong>
              </span>
              <a href="#rules" className="event-rules-link" onClick={handleOpenModal}>
                Event Rules &gt;
              </a>
            </div>
          </div>

          {/* Hero Image / Graphic */}
          <div className="airdrop-detail-hero-right">
            <img
              src="/images/airdrop-img/airdrop_detail_img.png"
              alt="Trade & Share 20,000 USDC"
              className="airdrop-detail-img"
            />
          </div>
        </div>

        {/* --- Web3 Newbie Reward Tasks Section --- */}
        <div className="airdrop-tasks-section">
          <div className="tasks-section-header">
            <div className="tasks-header-left">
              <h2 className="tasks-section-title">Web3 Newbie Reward Tasks</h2>
              <span className="badge-ongoing">Ongoing</span>
            </div>
            <a href="#rules" className="view-rules-link" onClick={handleOpenModal}>
              View Rules &gt;
            </a>
          </div>

          {/* Task Cards List */}
          <div className="tasks-list">
            {/* Task Card 1 */}
            <div className="task-card">
              <div className="task-card-left">
                <div className="task-num-badge">1</div>
                <div className="task-info">
                  <h3 className="task-title">New Wallet Deposit x10</h3>
                  <p className="task-desc">Make a deposit of at least $10 in your wallet.</p>
                  <span className="task-progress">Q1: 0 / 1</span>
                </div>
              </div>
              <div className="task-card-right">
                <div className="reward-val-wrap">
                  <span className="reward-val">2,000</span>
                  <span className="reward-token">USDC</span>
                </div>
                <button className="task-go-btn" onClick={handleOpenModal}>Go</button>
              </div>
            </div>

            {/* Task Card 2 */}
            <div className="task-card">
              <div className="task-card-left">
                <div className="task-num-badge">2</div>
                <div className="task-info">
                  <h3 className="task-title">Ondo Swap Volume x 200 USDC</h3>
                  <p className="task-desc">
                    Complete $200 USDC paid by completing your first Ondo token swap on BSC with a total volume of at least 200 USDC.
                  </p>
                  <span className="task-progress">Q1: 0 / 1</span>
                </div>
              </div>
              <div className="task-card-right">
                <div className="reward-val-wrap">
                  <span className="reward-val">3,000</span>
                  <span className="reward-token">USDC</span>
                </div>
                <button className="task-go-btn" onClick={handleOpenModal}>Go</button>
              </div>
            </div>

            {/* Task Card 3 */}
            <div className="task-card">
              <div className="task-card-left">
                <div className="task-num-badge">3</div>
                <div className="task-info">
                  <h3 className="task-title">BSC Swap Volume x 200 USDC</h3>
                  <p className="task-desc">
                    Complete swaps on BSC network with a total volume of at least $200 USDC.
                  </p>
                  <span className="task-progress">Q1: 0 / 1</span>
                </div>
              </div>
              <div className="task-card-right">
                <div className="reward-val-wrap">
                  <span className="reward-val">3,000</span>
                  <span className="reward-token">USDC</span>
                </div>
                <button className="task-go-btn" onClick={handleOpenModal}>Go</button>
              </div>
            </div>

            {/* Task Card 4 */}
            <div className="task-card">
              <div className="task-card-left">
                <div className="task-num-badge">4</div>
                <div className="task-info">
                  <h3 className="task-title">Polymarket First Trade Protection</h3>
                  <p className="task-desc">Place your first trade on Polymarket.</p>
                  <span className="task-progress">Q1: 0 / 1</span>
                </div>
              </div>
              <div className="task-card-right">
                <div className="reward-val-wrap">
                  <span className="reward-val">3,000</span>
                  <span className="reward-token">USDC</span>
                </div>
                <button className="task-go-btn" onClick={handleOpenModal}>Go</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Connect Wallet Modal */}
      <ConnectWalletModal
        isOpen={isWalletModalOpen}
        onClose={() => setIsWalletModalOpen(false)}
      />
    </div>
  );
};

export default AirdropDetails;

